// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pccContainer {
    width: 90%;
    background: linear-gradient(145deg, #0d1e1e 0%, #091616 100%);
    border: 1px solid #1c3333;
    border-radius: 14px;
    padding: 10px 16px;
    box-sizing: border-box;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.3), 0 0 1px 1px rgba(59, 179, 174, 0.12);
    display: flex;
    flex-direction: column;
    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.pccContainer:hover {
    border-color: #274848;
    box-shadow: 0 6px 22px rgba(0, 0, 0, 0.38), 0 0 16px rgba(59, 179, 174, 0.1);
}

.pccContainer.is-expanded {
    padding: 14px 18px 16px 18px;
    background: linear-gradient(145deg, #0e2020 0%, #081414 100%);
    border-color: #274848;
}

/* 1. Header Bar */
.pccBarHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.pccBarLeft {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.pccIconBadge {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: linear-gradient(135deg, rgba(59, 179, 174, 0.2) 0%, rgba(20, 36, 36, 0.5) 100%);
    border: 1px solid rgba(59, 179, 174, 0.35);
    color: #48D1CC;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.pccIconBadge.complete {
    background: linear-gradient(135deg, rgba(46, 204, 113, 0.2) 0%, rgba(20, 46, 30, 0.5) 100%);
    border-color: rgba(46, 204, 113, 0.4);
    color: #2ECC71;
}

.pccTitle {
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 14.5px;
    font-weight: 700;
    letter-spacing: -0.1px;
    white-space: nowrap;
}

/* Milestone Status Icons (Center of Bar) */
.pccMilestoneIcons {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 auto;
}

.pccIconChip {
    width: 32px;
    height: 32px;
    border-radius: 9px;
    background: #091717;
    border: 1px solid #182e2e;
    color: #48D1CC;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transition: all 0.18s ease;
}

.pccIconChip:hover {
    transform: translateY(-1px);
    border-color: #2b4e4e;
    background: #0f2424;
}

.pccIconChip.chip-success {
    color: #2ECC71;
    border-color: rgba(46, 204, 113, 0.3);
    background: rgba(46, 204, 113, 0.08);
}

.pccIconChip.chip-warning {
    color: #F39C12;
    border-color: rgba(243, 156, 18, 0.3);
    background: rgba(243, 156, 18, 0.08);
}

.pccIconChip.chip-pending {
    color: #F1C40F;
    border-color: rgba(241, 196, 15, 0.3);
    background: rgba(241, 196, 15, 0.08);
}

.pccMiniBadge {
    position: absolute;
    bottom: -3px;
    right: -3px;
    background: #091616;
    border-radius: 50%;
}

.chip-success .pccMiniBadge {
    color: #2ECC71;
}

.chip-warning .pccMiniBadge {
    color: #F39C12;
}

.chip-pending .pccMiniBadge {
    color: #F1C40F;
}

/* Right Section of Bar */
.pccBarRight {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.pccPercentageBadge {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border-radius: 99px;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 600;
    background: rgba(59, 179, 174, 0.15);
    color: #48D1CC;
    border: 1px solid rgba(59, 179, 174, 0.3);
    white-space: nowrap;
}

.pccPercentageBadge.complete {
    background: rgba(46, 204, 113, 0.15);
    color: #2ECC71;
    border-color: rgba(46, 204, 113, 0.35);
}

.pccExpandBtn {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: #102222;
    border: 1px solid #1a3333;
    color: #48D1CC;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.22s ease;
    padding: 0;
    outline: none;
}

.pccBarHeader:hover .pccExpandBtn {
    background: #173232;
    border-color: #3BB3AE;
    color: #FFFFFF;
}

.pccExpandBtn.rotated {
    transform: rotate(180deg);
}

/* 2. Expanded Drawer */
.pccExpandedDrawer {
    animation: pccSlideDown 0.24s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes pccSlideDown {
    from {
        opacity: 0;
        transform: translateY(-6px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.pccDrawerDivider {
    width: 100%;
    height: 1px;
    background: #172d2d;
    margin: 12px 0 14px 0;
}

/* Progress Container */
.pccProgressContainer {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 14px;
}

.pccProgressMeta {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.pccProgressText {
    color: #8fa6a6;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 500;
}

.pccProgressPercent {
    color: #48D1CC;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 600;
}

.pccProgressTrack {
    width: 100%;
    height: 6px;
    background-color: #061111;
    border: 1px solid #142828;
    border-radius: 99px;
    overflow: hidden;
    position: relative;
}

.pccProgressBar {
    height: 100%;
    border-radius: 99px;
    background: linear-gradient(90deg, #208782 0%, #3BB3AE 60%, #48D1CC 100%);
    box-shadow: 0 0 8px rgba(72, 209, 204, 0.45);
    transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.pccProgressBar.complete {
    background: linear-gradient(90deg, #1fa357 0%, #2ECC71 100%);
    box-shadow: 0 0 10px rgba(46, 204, 113, 0.5);
}

/* Detailed Steps List (Full Width Rows) */
.pccStepsList {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.pccStepRow {
    background: #081515;
    border: 1px solid #162a2a;
    border-radius: 10px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    box-sizing: border-box;
    transition: all 0.18s ease;
}

.pccStepRow:hover {
    background: #0c1e1e;
    border-color: #274848;
}

.pccStepRow.is-complete {
    border-color: rgba(46, 204, 113, 0.2);
}

.pccStepRowLeft {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    flex: 1 1;
}

.pccStepIconWrap {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #102424;
    color: #48D1CC;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.pccStepRow.is-complete .pccStepIconWrap {
    color: #2ECC71;
    background: rgba(46, 204, 113, 0.12);
}

.pccStepContent {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.pccStepTitle {
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 13.5px;
    font-weight: 600;
    line-height: 1.25;
}

.pccStepSubtitle {
    color: #7d9696;
    font-family: "Inter", sans-serif;
    font-size: 11.5px;
    line-height: 1.35;
}

.pccMissingText {
    color: #F39C12;
    font-weight: 500;
}

/* Step Row Right */
.pccStepRowRight {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.pccStepBadge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: "Inter", sans-serif;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
    white-space: nowrap;
}

.pccStepBadge.success {
    background: rgba(46, 204, 113, 0.15);
    color: #2ECC71;
    border: 1px solid rgba(46, 204, 113, 0.3);
}

.pccStepBadge.warning {
    background: rgba(243, 156, 18, 0.15);
    color: #F39C12;
    border: 1px solid rgba(243, 156, 18, 0.3);
}

.pccStepBadge.pending {
    background: rgba(241, 196, 15, 0.15);
    color: #F1C40F;
    border: 1px solid rgba(241, 196, 15, 0.3);
}

.pccStepActionBtn {
    background: #112525;
    border: 1px solid #1e3838;
    color: #48D1CC;
    font-family: "Inter", sans-serif;
    font-size: 11.5px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 6px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    transition: all 0.18s ease;
    white-space: nowrap;
}

.pccStepActionBtn:hover {
    background: #3BB3AE;
    color: #091616;
    border-color: #3BB3AE;
}

/* Responsive */
@media (max-width: 768px) {
    .pccContainer {
        width: 95%;
        padding: 10px 12px;
    }
    .pccTitle {
        font-size: 13.5px;
    }
    .pccPercentageBadge {
        font-size: 11px;
        padding: 2px 7px;
    }
    .pccStepRow {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    .pccStepRowRight {
        width: 100%;
        justify-content: space-between;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/ProfileCompletenessCard/ProfileCompletenessCard.css"],"names":[],"mappings":"AAEA;IACI,UAAU;IACV,6DAA6D;IAC7D,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,+EAA+E;IAC/E,aAAa;IACb,sBAAsB;IACtB,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,4EAA4E;AAChF;;AAEA;IACI,4BAA4B;IAC5B,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2FAA2F;IAC3F,0CAA0C;IAC1C,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,2FAA2F;IAC3F,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,cAAc;IACd,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;IAC1B,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,0DAA0D;AAC9D;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yEAAyE;IACzE,4CAA4C;IAC5C,mDAAmD;AACvD;;AAEA;IACI,4DAA4D;IAC5D,4CAA4C;AAChD;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;IACA;QACI,WAAW;QACX,8BAA8B;IAClC;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap\");\n\n.pccContainer {\n    width: 90%;\n    background: linear-gradient(145deg, #0d1e1e 0%, #091616 100%);\n    border: 1px solid #1c3333;\n    border-radius: 14px;\n    padding: 10px 16px;\n    box-sizing: border-box;\n    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.3), 0 0 1px 1px rgba(59, 179, 174, 0.12);\n    display: flex;\n    flex-direction: column;\n    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n}\n\n.pccContainer:hover {\n    border-color: #274848;\n    box-shadow: 0 6px 22px rgba(0, 0, 0, 0.38), 0 0 16px rgba(59, 179, 174, 0.1);\n}\n\n.pccContainer.is-expanded {\n    padding: 14px 18px 16px 18px;\n    background: linear-gradient(145deg, #0e2020 0%, #081414 100%);\n    border-color: #274848;\n}\n\n/* 1. Header Bar */\n.pccBarHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    width: 100%;\n    cursor: pointer;\n    user-select: none;\n}\n\n.pccBarLeft {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n}\n\n.pccIconBadge {\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    background: linear-gradient(135deg, rgba(59, 179, 174, 0.2) 0%, rgba(20, 36, 36, 0.5) 100%);\n    border: 1px solid rgba(59, 179, 174, 0.35);\n    color: #48D1CC;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.pccIconBadge.complete {\n    background: linear-gradient(135deg, rgba(46, 204, 113, 0.2) 0%, rgba(20, 46, 30, 0.5) 100%);\n    border-color: rgba(46, 204, 113, 0.4);\n    color: #2ECC71;\n}\n\n.pccTitle {\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14.5px;\n    font-weight: 700;\n    letter-spacing: -0.1px;\n    white-space: nowrap;\n}\n\n/* Milestone Status Icons (Center of Bar) */\n.pccMilestoneIcons {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin: 0 auto;\n}\n\n.pccIconChip {\n    width: 32px;\n    height: 32px;\n    border-radius: 9px;\n    background: #091717;\n    border: 1px solid #182e2e;\n    color: #48D1CC;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    transition: all 0.18s ease;\n}\n\n.pccIconChip:hover {\n    transform: translateY(-1px);\n    border-color: #2b4e4e;\n    background: #0f2424;\n}\n\n.pccIconChip.chip-success {\n    color: #2ECC71;\n    border-color: rgba(46, 204, 113, 0.3);\n    background: rgba(46, 204, 113, 0.08);\n}\n\n.pccIconChip.chip-warning {\n    color: #F39C12;\n    border-color: rgba(243, 156, 18, 0.3);\n    background: rgba(243, 156, 18, 0.08);\n}\n\n.pccIconChip.chip-pending {\n    color: #F1C40F;\n    border-color: rgba(241, 196, 15, 0.3);\n    background: rgba(241, 196, 15, 0.08);\n}\n\n.pccMiniBadge {\n    position: absolute;\n    bottom: -3px;\n    right: -3px;\n    background: #091616;\n    border-radius: 50%;\n}\n\n.chip-success .pccMiniBadge {\n    color: #2ECC71;\n}\n\n.chip-warning .pccMiniBadge {\n    color: #F39C12;\n}\n\n.chip-pending .pccMiniBadge {\n    color: #F1C40F;\n}\n\n/* Right Section of Bar */\n.pccBarRight {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n}\n\n.pccPercentageBadge {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 10px;\n    border-radius: 99px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    background: rgba(59, 179, 174, 0.15);\n    color: #48D1CC;\n    border: 1px solid rgba(59, 179, 174, 0.3);\n    white-space: nowrap;\n}\n\n.pccPercentageBadge.complete {\n    background: rgba(46, 204, 113, 0.15);\n    color: #2ECC71;\n    border-color: rgba(46, 204, 113, 0.35);\n}\n\n.pccExpandBtn {\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    background: #102222;\n    border: 1px solid #1a3333;\n    color: #48D1CC;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.22s ease;\n    padding: 0;\n    outline: none;\n}\n\n.pccBarHeader:hover .pccExpandBtn {\n    background: #173232;\n    border-color: #3BB3AE;\n    color: #FFFFFF;\n}\n\n.pccExpandBtn.rotated {\n    transform: rotate(180deg);\n}\n\n/* 2. Expanded Drawer */\n.pccExpandedDrawer {\n    animation: pccSlideDown 0.24s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes pccSlideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-6px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.pccDrawerDivider {\n    width: 100%;\n    height: 1px;\n    background: #172d2d;\n    margin: 12px 0 14px 0;\n}\n\n/* Progress Container */\n.pccProgressContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-bottom: 14px;\n}\n\n.pccProgressMeta {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.pccProgressText {\n    color: #8fa6a6;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.pccProgressPercent {\n    color: #48D1CC;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.pccProgressTrack {\n    width: 100%;\n    height: 6px;\n    background-color: #061111;\n    border: 1px solid #142828;\n    border-radius: 99px;\n    overflow: hidden;\n    position: relative;\n}\n\n.pccProgressBar {\n    height: 100%;\n    border-radius: 99px;\n    background: linear-gradient(90deg, #208782 0%, #3BB3AE 60%, #48D1CC 100%);\n    box-shadow: 0 0 8px rgba(72, 209, 204, 0.45);\n    transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.pccProgressBar.complete {\n    background: linear-gradient(90deg, #1fa357 0%, #2ECC71 100%);\n    box-shadow: 0 0 10px rgba(46, 204, 113, 0.5);\n}\n\n/* Detailed Steps List (Full Width Rows) */\n.pccStepsList {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n}\n\n.pccStepRow {\n    background: #081515;\n    border: 1px solid #162a2a;\n    border-radius: 10px;\n    padding: 10px 14px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 14px;\n    box-sizing: border-box;\n    transition: all 0.18s ease;\n}\n\n.pccStepRow:hover {\n    background: #0c1e1e;\n    border-color: #274848;\n}\n\n.pccStepRow.is-complete {\n    border-color: rgba(46, 204, 113, 0.2);\n}\n\n.pccStepRowLeft {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n    flex: 1;\n}\n\n.pccStepIconWrap {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    background: #102424;\n    color: #48D1CC;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.pccStepRow.is-complete .pccStepIconWrap {\n    color: #2ECC71;\n    background: rgba(46, 204, 113, 0.12);\n}\n\n.pccStepContent {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.pccStepTitle {\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13.5px;\n    font-weight: 600;\n    line-height: 1.25;\n}\n\n.pccStepSubtitle {\n    color: #7d9696;\n    font-family: \"Inter\", sans-serif;\n    font-size: 11.5px;\n    line-height: 1.35;\n}\n\n.pccMissingText {\n    color: #F39C12;\n    font-weight: 500;\n}\n\n/* Step Row Right */\n.pccStepRowRight {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n}\n\n.pccStepBadge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 3px 8px;\n    border-radius: 6px;\n    white-space: nowrap;\n}\n\n.pccStepBadge.success {\n    background: rgba(46, 204, 113, 0.15);\n    color: #2ECC71;\n    border: 1px solid rgba(46, 204, 113, 0.3);\n}\n\n.pccStepBadge.warning {\n    background: rgba(243, 156, 18, 0.15);\n    color: #F39C12;\n    border: 1px solid rgba(243, 156, 18, 0.3);\n}\n\n.pccStepBadge.pending {\n    background: rgba(241, 196, 15, 0.15);\n    color: #F1C40F;\n    border: 1px solid rgba(241, 196, 15, 0.3);\n}\n\n.pccStepActionBtn {\n    background: #112525;\n    border: 1px solid #1e3838;\n    color: #48D1CC;\n    font-family: \"Inter\", sans-serif;\n    font-size: 11.5px;\n    font-weight: 600;\n    padding: 4px 10px;\n    border-radius: 6px;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    transition: all 0.18s ease;\n    white-space: nowrap;\n}\n\n.pccStepActionBtn:hover {\n    background: #3BB3AE;\n    color: #091616;\n    border-color: #3BB3AE;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .pccContainer {\n        width: 95%;\n        padding: 10px 12px;\n    }\n    .pccTitle {\n        font-size: 13.5px;\n    }\n    .pccPercentageBadge {\n        font-size: 11px;\n        padding: 2px 7px;\n    }\n    .pccStepRow {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n    }\n    .pccStepRowRight {\n        width: 100%;\n        justify-content: space-between;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
